import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LogoShowcase = lazy(() => import('../pages/logo-showcase/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DonatePage = lazy(() => import('../pages/donate/page'));
const MasAcademyPage = lazy(() => import('../pages/mas-academy/page'));
const JoinPage = lazy(() => import('../pages/join/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/[slug]/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/logo-options',
    element: <LogoShowcase />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/donate',
    element: <DonatePage />,
  },
  {
    path: '/mas-academy',
    element: <MasAcademyPage />,
  },
  {
    path: '/join',
    element: <JoinPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
